import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { APP_SHELL_CONFIG } from './app-shell.config';

const DEFAULT_MOBILE_BREAKPOINTS: readonly string[] = [Breakpoints.Handset, Breakpoints.TabletPortrait];

@Injectable({ providedIn: 'root' })
export class AppShellResponsiveService {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly mobileBreakpoints =
    inject(APP_SHELL_CONFIG, { optional: true })?.mobileBreakpoints ?? DEFAULT_MOBILE_BREAKPOINTS;

  readonly isMobile = toSignal(
    this.breakpointObserver.observe(this.mobileBreakpoints as string[]).pipe(map((result) => result.matches)),
    { initialValue: this.breakpointObserver.isMatched(this.mobileBreakpoints as string[]) },
  );
}
